export const FLIGHT_NUMBER = "Flight #";

export const HEADER = (departureDate: string) =>
  `Select an Airline to view flight numbers departing on ${departureDate}`;
